// extracted by mini-css-extract-plugin
export default {"main":"Dashboard_main__jbl3d"};